import React, { useState, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
// import user4_2x from "/images/user4_2x.png";
import Button from '@material-ui/core/Button';
import Alert from '@material-ui/lab/Alert';
import axios from 'axios';
import { AuthContext } from '../../../@jumbo/components/context/AuthContext';
import RefreshToken from '../../partials/RefreshToken';

const useStyles = makeStyles(theme => ({
  rightAlign: {
    textAlign: 'right',
  },

  buttonStyle: {
    padding: '10px 32px',
    fontSize: '16px',
    color: 'white',
    fontWeight: 600,
    textTransform: 'capitalize',
    borderRadius: '8px',
    boxShadow: 'none',
    '&:hover': {
      boxShadow: 'none',
    },
  },
  uploadButtonStyle: {
    padding: '10px 32px',
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'capitalize',
    borderRadius: '8px',
    boxShadow: 'none',
    '&:hover': {
      boxShadow: 'none',
    },
  },
  backButton: {
    fontSize: '16px',
    textTransform: 'capitalize',
    '&:hover': {
      background: 'none',
    },
    color: '#19181699',
  },

  marginRightStyle: {
    marginRight: 15,
  },

  textField: {
    [`& fieldset`]: {
      borderRadius: 8,
    },
    '& .MuiOutlinedInput-input': {
      fontSize: '14px',
    },
    '& .MuiOutlinedInput-inputMarginDense': {
      padding: 13,
    },
  },
  imageStyle: {
    borderRadius: '50%',
  },
  imageDivStyle: {
    margin: '30px 0 20px',
  },
  divMarginStyle: {
    margin: '40px 0',
  },
  error: {
    marginBottom: 15,
  },
}));

const ProfileSettings = () => {
  const classes = useStyles();
  const { login, glob_pay_admin_auth, logout } = useContext(AuthContext);
  const [imageFile, setImageFile] = useState(null);
  const [preview, setPreview] = useState('/images/user4_2x.png');
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');

  const imageUpload = e => {
    if (e.target.files && e.target.files[0]) {
      let file = e.target.files[0];

      const reader = new FileReader();
      reader.onload = x => {
        setImageFile(file);
        setPreview(x.target.result);
      };
      reader.readAsDataURL(file);
    } else {
      setImageFile(imageFile);
      setPreview(preview);
    }
  };

  const handleClick = () => {
    document.getElementById('fileUpload').click();
  };
  const handleSubmit = async e => {
    e.preventDefault();
    // setLoading(true);
    try {
      let token = await RefreshToken(glob_pay_admin_auth, logout, login);
      const formdata = new FormData();
      formdata.append('file', imageFile);
      let response = await axios({
        url: '/api/v1/private/picture',
        method: 'put',
        data: formdata,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setMessageType('success');
      setMessage('Password Changed');
    } catch (error) {
      setMessageType('error');
      setMessage(error.response.data.errors.toString());
    }
    // setLoading(false);
  };
  return (
    <>
      <Typography variant="h2" gutterBottom>
        Edit Profile
      </Typography>
      <Typography variant="body1">Only you can view the changes that has been made</Typography>
      {message ? (
        <Alert variant="outlined" severity="error" className={classes.error}>
          {message}
        </Alert>
      ) : null}
      <div className={classes.imageDivStyle}>
        <img src={preview} alt="" height="147px" className={classes.imageStyle} />
      </div>
      <input type="file" name="file" id="fileUpload" hidden accept="image/*" onChange={imageUpload} />
      <Button variant="outlined" color="primary" className={classes.uploadButtonStyle} onClick={handleClick}>
        Upload Picture
      </Button>

      <div className={classes.divMarginStyle}>
        <Typography variant="body1" gutterBottom>
          Your Display Name
        </Typography>
        <TextField
          id="transaction-id"
          size="small"
          fullWidth
          placeholder="Enter Name"
          variant="outlined"
          className={classes.textField}
        />
      </div>
      <div className={classes.rightAlign}>
        <Button
          className={`${classes.backButton} ${classes.marginRightStyle}`}
          disableRipple={true}
          onClick={() => window.history.back()}
          style={{ fontWeight: 600, padding: '10px 32px' }}>
          Cancel
        </Button>
        <Button variant="contained" color="primary" className={classes.buttonStyle} onClick={handleSubmit}>
          Save
        </Button>
      </div>
    </>
  );
};

export default ProfileSettings;
